/**
 * Created by Jaime Bonilla Venegas on 2017-06-13.
 *
 * contentStyle={{ width: '75%', maxWidth: 'none' }}
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { AduanasFilter } from '../../components/filters';
import IconButton from 'material-ui/IconButton';
import { List } from '../../components/data-containers';
import { Item } from './components';
import Form from '../../forms';
import * as actions from './actions';
import { SubHeader, EmptyList } from '../../components/layout';
import { serializeParams } from '../../common/helpers';
import Snackbar from 'material-ui/Snackbar';
import {
    getPagePermissions,
    CUSTOMS_HOUSES_PERMISSION,
} from '../../security/permissions';

class Aduanas extends Component {

    componentWillMount() {
        this.props.fetchData('customsHouses', 'customsHouses', 'customsHouses/search/findAllByOrderByNameAsc');
    }

    refresh() {
        console.log("rntro");
        this.props.fetchData('customsHouses', 'customsHouses', 'customsHouses/search/findAllByOrderByNameAsc');
    }

    CreateURL(table, filter, projection) {
        console.log(filter);

        return (table.concat(filter).concat(projection));
    }

    formHandler(open, path, form) {
        this.props.notify({ op: 'update', path: 'formOpen', value: open });
        switch (path) {
            case 'NEW_CUSTOMS_HOUSE':
                this.props.saveCustomsHouse(form);
                break;
            default:
        }
    }

    render() {
        const { formOpen, notify, customsHouses = { items: [] }, showNotification, showMessage, notificationColor, pagePermissions } = this.props;
        const styles = {
            smallIcon: {
                width: 23,
                height: 23,
            },
            small: {
                width: 23,
                height: 23,
                padding: 0,
                verticalAlign: -16,
            },
        };

        return (
            <div>
                <SubHeader
                    title="Aduanas"
                    showRefresh={false}
                    onPressHeaderButton={() => this.formHandler(true, 'formOpen')}
                    showAddButton={pagePermissions.create}
                />
                <div className="navbar visible-xs" style={{ padding: '0rem 2.3rem' }}>
                    <button
                        className="btn btn-default navbar-btn btn-filtros"
                        data-toggle="collapse"
                        data-target="#filter-sidebar"
                    >
                        <i className="fa fa-tasks" /> Panel de filtros
                    </button>
                </div>
                <div>
                    <AduanasFilter
                        onSearch={(params) => {
                            Object.keys(params).forEach(key => params[key] === "" ? delete params[key] : '');
                            const concat = isEmpty(params) ? '?' : '&';
                            this.props.fetchData('customsHouses', 'customsHouses', this.CreateURL('customsHouses', serializeParams(params), `${concat}projection=findAllByOrderByNameAsc`));
                        }}
                        onClear={(params) => {
                            this.props.fetchData('customsHouses', 'customsHouses', 'customsHouses?projection=findAllByOrderByNameAsc');
                        }}
                    >
                        {
                            customsHouses.length === 0 ? <EmptyList /> :
                                customsHouses.map((house, index) => {
                                    return (
                                        <Item
                                            key={index}
                                            customsHouse={house}
                                            allowUpdate={pagePermissions.update}
                                            allowDelete={pagePermissions.delete}
                                            actions={{
                                                deleteCustomsHouse: (value) => {
                                                    this.props.deleteCustomsHouse(value, index);
                                                }
                                            }}
                                            onSave={(newCustomsHouse) => {
                                                //This is only updating the item on memory
                                                //Replace this with the action that saves results on server
                                                this.props.editCustomsHouse(newCustomsHouse, index);
                                            }}
                                        />
                                    );
                                })
                        }
                    </AduanasFilter>
                </div>
                <Form
                    title="Nueva Aduana"
                    type="aduana"
                    open={formOpen}
                    actions={{}}
                    onModalClosed={() => this.formHandler(false, 'openForm')}
                    onSave={(form) => {
                        this.formHandler(false, 'NEW_CUSTOMS_HOUSE', form);
                    }}//Will return if form is valid to send it
                />

                <Snackbar
                    bodyStyle={{
                        top: 0,
                        bottom: 'auto',
                        backgroundColor: notificationColor,
                        maxWidth: "800px",
                        height: "55px",
                        lineHeight: "28px",
                        left: (window.innerWidth - 288) / 2,
                        /*transform: this.props.errorMessage ?
                          'translate3d(0, 0, 0)' :
                          "translate3d(0, "+ -(window.innerHeight - 100) + "px , 0)"*/
                    }}
                    open={showNotification}
                    message={showMessage}
                    autoHideDuration={4000}
                    onRequestClose={() => this.props.notify({ op: 'update', path: 'showNotification', value: false })}
                />
            </div>
        );
    }
}

const mapStateToProps = ({ aduanas, userData, userData: { permissions } }) => {
    return {
        ...aduanas,
        userData,
        pagePermissions: getPagePermissions(CUSTOMS_HOUSES_PERMISSION, permissions)
    };
};

export default connect(mapStateToProps, { ...actions })(Aduanas);



// WEBPACK FOOTER //
// ./containers/aduanas/index.js